//blog.js
import './bootstrap';

import { createApp, defineAsyncComponent } from 'vue';

import ConsentBanner from './components/ConsentBanner.vue';

const app = createApp({});

app.component('gallery-lazy-loader', defineAsyncComponent(() => import('./components/GalleryLazyLoader.vue')))
app.component('consent-banner', ConsentBanner);

app.mount('#app');
